import type { Route } from 'next'

const sanitizeSegment = (segment: string | undefined): string | null => {
  if (!segment) {
    return null
  }

  const trimmed = segment.trim().replace(/^\/+|\/+$/g, '')
  if (!trimmed) {
    return null
  }

  return trimmed
}

const encodeSegments = (segments: Array<string | undefined>): string[] =>
  segments
    .map(sanitizeSegment)
    .filter((segment): segment is string => Boolean(segment))
    .map((segment) => segment.split('/').filter(Boolean).map(encodeURIComponent).join('/'))
    .filter(Boolean)

const buildPath = (...segments: Array<string | undefined>): Route => {
  const encoded = encodeSegments(segments)
  const path = encoded.length > 0 ? `/${encoded.join('/')}` : '/'
  return path
}

export const buildTradePath = (trade: string): Route => buildPath(trade)

export const buildTradeStatePath = (trade: string, state: string): Route => buildPath(trade, state)

export const buildTradeStateCityPath = (trade: string, state: string, city: string): Route =>
  buildPath(trade, state, city)
